import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { ScanDialog, EtichettaDialog, NuovoIngredienteDialog } from "../components/lotti/LottiDialogs";
import { LottoPositionDialog } from "../components/lotti/LottoPositionDialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Checkbox } from "../components/ui/checkbox";
import PreparaDialog from "../components/PreparaDialog";
import { toast } from "sonner";
import { 
  Camera, Plus, Printer, Calendar, X, ChefHat, 
  Search, Archive, MapPin, RotateCcw,
  RotateCw, SlidersHorizontal
} from "lucide-react";

// Import nuovi componenti modulari
import {
  LottoCard,
  LottoActionModal,
  ArchiveConfirmDialog,
  CongelaLottoDialog,
  ScongelaLottoDialog,
  LabelSettingsDialog,
  PostCreazioneLottoDialog,
} from "../components/lotti";
import IngredienteCombobox from "../components/lotti/IngredienteCombobox";
import StatoCucinaHero from "../components/lotti/StatoCucinaHero";
import FabSpeedDial from "../components/lotti/FabSpeedDial";
import FiltersBottomSheet from "../components/lotti/FiltersBottomSheet";
import FatturaSheet from "../components/lotti/FatturaSheet";
import { gruppoConservazione } from "../components/lotti/conservazione";
import { useLocalFilePreviews } from "../hooks/useLocalFilePreviews";
import {
  formatNomeOperatore,
} from "./lottiHelpers";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const isDataScadenzaPassata = (value) => {
  if (!value) return false;
  const scadenza = new Date(`${value.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(scadenza.getTime())) return false;
  const oggi = new Date();
  oggi.setHours(0, 0, 0, 0);
  return scadenza < oggi;
};

const Lotti = () => {
  const { getAuthHeaders, user, localeCorrente } = useAuth();
  const navigate = useNavigate();
  const [lotti, setLotti] = useState([]);
  const [lottiArchiviati, setLottiArchiviati] = useState([]);
  const [ingredienti, setIngredienti] = useState([]);
  const [fornitori, setFornitori] = useState([]);
  const [posizioni, setPosizioni] = useState([]);
  const [frigoriferi, setFrigoriferi] = useState([]);
  const fetchRequestRef = useRef(0);
  const loadedLocaleRef = useRef(null);
  const [categorie, setCategorie] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Ricetta iniziale da URL (da pagina Ricette)
  const [ricettaIdDaUrl, setRicettaIdDaUrl] = useState(null);
  
  // Lotto evidenziato da URL (da alert scadenze)
  const [highlightLottoId, setHighlightLottoId] = useState(null);
  
  // Tab corrente: "attivi" o "archivio"
  const [filtersSheetOpen, setFiltersSheetOpen] = useState(false);
  
  // Ricerca e filtri
  const [searchQuery, setSearchQuery] = useState("");
  const [filterGiorni, setFilterGiorni] = useState(null);
  const [filterCategoria, setFilterCategoria] = useState(null);
  const [filterStato, setFilterStato] = useState("tutti"); // tutti | frigo | temp_ambiente | congelato | scongelato | scaduti
  
  // Dialog states
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [positionOnlyLotto, setPositionOnlyLotto] = useState(null);
  const [positionOnlyValue, setPositionOnlyValue] = useState("");
  const [positionOnlySaving, setPositionOnlySaving] = useState(false);
  const [ocrLoading, setOcrLoading] = useState(false);
  
  // Modale azioni lotto
  const [selectedLottoForAction, setSelectedLottoForAction] = useState(null);
  const [actionModalOpen, setActionModalOpen] = useState(false);

  // Congelamento / Scongelamento HACCP
  const [congelaLotto, setCongelaLotto] = useState(null);
  const [congelaForm, setCongelaForm] = useState({ data: "", mesi: 3, data_scadenza_custom: "", note: "", metodo: "congelatore", quantita_parziale: "" });
  const [scongelaLotto, setScongelaLotto] = useState(null);
  const [scongelaForm, setScongelaForm] = useState({ data: "", giorni: 2, data_scadenza_custom: "", note: "", destinazione: "frigo", quantita_parziale: "" });

  // Dialog post-creazione lotto (conservazione e posizione)
  const [postCreaLotto, setPostCreaLotto] = useState(null); // { id, nome }
  const [savingStato, setSavingStato] = useState(false);
  
  // Modale dettaglio ingredienti

  
  // Dialogo archivia/elimina
  const [archiveDialogOpen, setArchiveDialogOpen] = useState(false);
  const [lottoToArchive, setLottoToArchive] = useState(null);
  
  // Form state
  const [form, setForm] = useState({
    ingrediente_id: "",
    nome_prodotto: "",
    numero_lotto: "",
    data_scadenza: "",
    data_apertura: new Date().toISOString().split('T')[0],
    data_scadenza_aperto: "",
    quantita_testo: "",
    quantita_preparata: "",
    unita_misura: "kg",
    posizione: "",
    operatore: "",
    immagine_path: "",
    fattura_immagine_path: "",
    categoria: "",
    is_composto: false,
    ingredienti_lotti_ids: [],
    ingredienti_dettaglio: null,
  });
  
  // Selezione per stampa
  const [selectedIds, setSelectedIds] = useState([]);
  
  // Ordinamento
  const [sortBy, setSortBy] = useState("scadenza"); // "scadenza" | "creazione" | "ricetta"
  
  // Dialog per nuova posizione
  
  // Dialog per nuovo ingrediente
  const [newIngredienteDialogOpen, setNewIngredienteDialogOpen] = useState(false);
  const [newIngredienteForm, setNewIngredienteForm] = useState({ nome: "", categoria_id: "", unita_misura: "kg" });
  
  // Dialog Prepara
  const [preparaDialogOpen, setPreparaDialogOpen] = useState(false);
  
  // Scansione
  const fileInputRef = useRef(null);
  const [capturedImages, setCapturedImages] = useState([]);
  const [scanDialogOpen, setScanDialogOpen] = useState(false);

  // Carica Fattura (galleria storico + nuova foto)
  const fatturaFileInputRef = useRef(null);
  const [fatturaSheetOpen, setFatturaSheetOpen] = useState(false);
  const [fatturaStorico, setFatturaStorico] = useState([]);
  const [fatturaUploading, setFatturaUploading] = useState(false);
  const { urls: fatturaPreviewUrls, remember: rememberFatturaPreview, clear: clearFatturaPreviews, get: getFatturaPreview } = useLocalFilePreviews();

  useEffect(() => { if (!scanDialogOpen) clearFatturaPreviews(); }, [scanDialogOpen, clearFatturaPreviews]);

  // Impostazioni etichetta (dimensioni in mm + rotazione)
  const [labelSize, setLabelSize] = useState({ width: 50, height: 30, rotated: false });
  const [labelSettingsOpen, setLabelSettingsOpen] = useState(false);
  const [tempLabelSize, setTempLabelSize] = useState({ width: 50, height: 30, rotated: false });

  // Carica dimensioni etichetta da DB (persistente tra deploy) + fallback localStorage
  useEffect(() => {
    if (localeCorrente?.id) {
      // Prima prova dal DB
      axios.get(`${API}/locali/${localeCorrente.id}/settings`, { headers: getAuthHeaders() })
        .then(res => {
          if (res.data?.label_size) {
            setLabelSize(res.data.label_size);
            setTempLabelSize(res.data.label_size);
            return;
          }
          // Fallback localStorage
          const saved = localStorage.getItem(`label_size_${localeCorrente.id}`);
          if (saved) {
            try {
              const parsed = JSON.parse(saved);
              setLabelSize(parsed);
              setTempLabelSize(parsed);
            } catch {}
          }
        })
        .catch(() => {
          const saved = localStorage.getItem(`label_size_${localeCorrente.id}`);
          if (saved) {
            try {
              const parsed = JSON.parse(saved);
              setLabelSize(parsed);
              setTempLabelSize(parsed);
            } catch {}
          }
        });
    }
  }, [localeCorrente?.id]);

  const saveLabelSize = () => {
    const w = Math.max(20, Math.min(150, Number(tempLabelSize.width) || 50));
    const h = Math.max(15, Math.min(100, Number(tempLabelSize.height) || 30));
    const newSize = { width: w, height: h, rotated: !!tempLabelSize.rotated };
    setLabelSize(newSize);
    // Salva sia in DB che in localStorage
    if (localeCorrente?.id) {
      localStorage.setItem(`label_size_${localeCorrente.id}`, JSON.stringify(newSize));
      axios.put(`${API}/locali/${localeCorrente.id}/settings`, { label_size: newSize }, { headers: getAuthHeaders() }).catch(() => {});
    }
    setLabelSettingsOpen(false);
    toast.success(`Formato etichetta: ${w}mm x ${h}mm${newSize.rotated ? ' (ruotata 90°)' : ''}`);
  };

  const fetchData = async () => {
    if (!localeCorrente) {
      fetchRequestRef.current += 1;
      loadedLocaleRef.current = null;
      setLotti([]);
      setFrigoriferi([]);
      setLoading(false);
      return;
    }
    const requestId = ++fetchRequestRef.current;
    const requestLocale = localeCorrente.id;
    if (loadedLocaleRef.current !== requestLocale) {
      setLotti([]);
      setIngredienti([]);
      setPosizioni([]);
      setLoading(true);
    }
    setFrigoriferi([]);
    
    try {
      const headers = getAuthHeaders();
      const localeParam = `locale_id=${requestLocale}`;
      
      const [lottiAttiviRes, lottiArchivioRes, ingredientiRes, posizioniRes, fornitoriRes, categorieRes, frigoriferiRes] = await Promise.all([
        axios.get(`${API}/lotti?${localeParam}&archived=false`, { headers }),
        axios.get(`${API}/lotti?${localeParam}&archived=true`, { headers }),
        axios.get(`${API}/ingredienti?${localeParam}`, { headers }),
        axios.get(`${API}/posizioni?${localeParam}`, { headers }),
        axios.get(`${API}/fornitori`, { headers }),
        axios.get(`${API}/categorie-ingredienti?${localeParam}`, { headers }),
        axios.get(`${API}/frigoriferi?${localeParam}`, { headers }).catch(() => ({ data: [] }))
      ]);
      if (requestId !== fetchRequestRef.current) return;
      
      setLotti(lottiAttiviRes.data);
      setLottiArchiviati(lottiArchivioRes.data);
      setIngredienti(ingredientiRes.data);
      setPosizioni(posizioniRes.data);
      setFrigoriferi(Array.isArray(frigoriferiRes.data) ? frigoriferiRes.data.filter(f => f.locale_id === requestLocale) : []);
      loadedLocaleRef.current = requestLocale;
      setFornitori(fornitoriRes.data);
      setCategorie(categorieRes.data);
    } catch (error) {
      console.error("Lotti fetch error:", error);
      toast.error("Errore nel caricamento dei lotti. Riprova.");
    } finally {
      if (requestId === fetchRequestRef.current) setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchFatturaStorico();
  }, [localeCorrente]);

  // Gestione ricetta_id e lotto_id da URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ricettaId = params.get('ricetta_id');
    const lottoId = params.get('lotto_id');
    if (ricettaId) {
      setRicettaIdDaUrl(ricettaId);
      setPreparaDialogOpen(true);
      window.history.replaceState({}, '', window.location.pathname);
    }
    if (lottoId) {
      setHighlightLottoId(lottoId);
      window.history.replaceState({}, '', window.location.pathname);
      // Scroll al lotto dopo un breve delay per permettere il rendering
      setTimeout(() => {
        const el = document.querySelector(`[data-lotto-id="${lottoId}"]`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          el.classList.add('ring-2', 'ring-amber-400');
          setTimeout(() => el.classList.remove('ring-2', 'ring-amber-400'), 3000);
        }
      }, 500);
    }
  }, []);

  const getIngredienteNome = (ingredienteId, prodottoId, lotto) => {
    // Per preparazioni/lotti composti, mostra il nome della preparazione
    if (lotto?.is_composto && lotto?.nome_preparazione) {
      return lotto.nome_preparazione;
    }
    // Nome libero (testo)
    if (lotto?.nome_prodotto) {
      return lotto.nome_prodotto;
    }
    // Cerca per ingrediente_id
    if (ingredienteId) {
      const ing = ingredienti.find(i => i.id === ingredienteId);
      if (ing) return ing.nome;
    }
    // Fallback
    return "Prodotto";
  };
  const getNomePosizione = (id) => {
    if (!id) return "";
    return frigoriferi.find(f => f.id === id)?.nome ||
      posizioni.find(p => p.id === id)?.nome || "Posizione precedente non disponibile";
  };
  const handlePositionOnlySave = async () => {
    if (!positionOnlyLotto) return;
    setPositionOnlySaving(true);
    try {
      await axios.patch(`${API}/lotti/${positionOnlyLotto.id}`, { posizione: positionOnlyValue || "" }, { headers: getAuthHeaders() });
      setPositionOnlyLotto(null);
      await fetchData();
      toast.success("Posizione aggiornata");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Impossibile aggiornare la posizione");
    } finally {
      setPositionOnlySaving(false);
    }
  };

  const getDaysUntil = (dataScadenza) => {
    if (!dataScadenza) return 999;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const scadenza = new Date(dataScadenza);
    scadenza.setHours(0, 0, 0, 0);
    return Math.ceil((scadenza - today) / (1000 * 60 * 60 * 24));
  };

  // Filtra e ordina lotti
  const getFilteredLotti = (lottiList) => {
    let filtered = lottiList;
    
    // Filtro ricerca testuale
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(l => {
        const ingredienteNome = getIngredienteNome(l.ingrediente_id, l.prodotto_id, l).toLowerCase();
        const numeroLotto = (l.numero_lotto || "").toLowerCase();
        const internoLotto = (l.interno_lotto || "").toLowerCase();
        const nomePrep = (l.nome_preparazione || "").toLowerCase();
        return ingredienteNome.includes(query) || numeroLotto.includes(query) || internoLotto.includes(query) || nomePrep.includes(query);
      });
    }
    
    // Filtro giorni scadenza
    if (filterGiorni) {
      filtered = filtered.filter(l => getDaysUntil(l.data_scadenza_aperto || l.data_scadenza) <= filterGiorni);
    }
    
    // Filtro categoria
    if (filterCategoria) {
      filtered = filtered.filter(l => l.categoria === filterCategoria);
    }

    // Filtro stato HACCP
    if (filterStato && filterStato !== "tutti") {
      filtered = filterStato === "scaduti"
        ? filtered.filter(l => getDaysUntil(l.data_scadenza_aperto || l.data_scadenza) < 0)
        : filtered.filter(l => filterStato === "congelato"
          ? l.stato === "congelato" : gruppoConservazione(l) === filterStato);
    }
    
    // Ordina
    return [...filtered].sort((a, b) => {
      if (sortBy === "creazione") {
        const da = a.data_apertura || a.created_at?.split("T")[0] || "";
        const db2 = b.data_apertura || b.created_at?.split("T")[0] || "";
        return da.localeCompare(db2);
      }
      if (sortBy === "ricetta") {
        const na = getIngredienteNome(a.ingrediente_id, a.prodotto_id, a).toLowerCase();
        const nb = getIngredienteNome(b.ingrediente_id, b.prodotto_id, b).toLowerCase();
        return na.localeCompare(nb);
      }
      // Default: scadenza
      return new Date(a.data_scadenza_aperto || a.data_scadenza) - new Date(b.data_scadenza_aperto || b.data_scadenza);
    });
  };

  const sortedLotti = getFilteredLotti(lotti);
  const sortedLottiArchiviati = getFilteredLotti(lottiArchiviati);

  // Contatori
  const lottiScaduti = lotti.filter(l => getDaysUntil(l.data_scadenza_aperto || l.data_scadenza) < 0).length;
  const lottiInScadenza = lotti.filter(l => {
    const days = getDaysUntil(l.data_scadenza_aperto || l.data_scadenza);
    return days >= 0 && days <= 7;
  }).length;

  // Categorie uniche
  const categorieUsate = [...new Set(lotti.map(l => l.categoria).filter(Boolean))];

  // Conteggi per stato HACCP
  const countByStato = {
    frigo: lotti.filter(l => gruppoConservazione(l) === "frigo").length,
    temp_ambiente: lotti.filter(l => gruppoConservazione(l) === "temp_ambiente").length,
    congelato: lotti.filter(l => l.stato === "congelato").length,
    scongelato: lotti.filter(l => l.stato === "scongelato").length,
    scaduti: lotti.filter(l => getDaysUntil(l.data_scadenza_aperto || l.data_scadenza) < 0).length,
  };

  // --- HANDLERS ---

  const openDialog = (item = null) => {
    if (item) {
      setEditItem(item);
      setForm({
        _editId: item.id,
        ingrediente_id: item.ingrediente_id || "",
        nome_prodotto: item.nome_prodotto || "",
        numero_lotto: item.numero_lotto,
        data_scadenza: item.data_scadenza,
        data_apertura: item.data_apertura || '',
        data_scadenza_aperto: item.data_scadenza_aperto || "",
        quantita_testo: item.quantita_testo || "",
        quantita_preparata: item.quantita_preparata != null ? String(item.quantita_preparata) : "",
        unita_misura: item.unita_misura || "",
        posizione: item.posizione || "",
        operatore: item.operatore || '',
        immagine_path: item.immagine_path || "",
        categoria: item.categoria || "",
        is_composto: item.is_composto || false,
        ingredienti_lotti_ids: item.ingredienti_lotti_ids || [],
        ingredienti_dettaglio: item.ingredienti_dettaglio || null,
      });
    } else {
      setEditItem(null);
      setForm({
        ingrediente_id: "",
        nome_prodotto: "",
        numero_lotto: "",
        data_scadenza: "",
        data_apertura: new Date().toISOString().split('T')[0],
        data_scadenza_aperto: "",
        quantita_testo: "",
        quantita_preparata: "",
        unita_misura: "",
        posizione: "",
        operatore: formatNomeOperatore(user),
        immagine_path: "",
        categoria: "",
        is_composto: false,
        ingredienti_lotti_ids: []
      });
    }
    setDialogOpen(true);
  };

  // Click su card lotto
  const handleLottoClick = (lotto) => {
    toast.dismiss();
    setSelectedLottoForAction(lotto);
    setActionModalOpen(true);
  };

  // Toggle selezione per stampa
  const toggleSelect = (id) => {
    setSelectedIds(prev => 
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  // Seleziona/Deseleziona tutti (solo attivi nella pagina principale)
  const toggleSelectAll = () => {
    if (selectedIds.length === sortedLotti.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(sortedLotti.map(l => l.id));
    }
  };

  // Archivia lotto
  const handleArchive = async (lottoId) => {
    try {
      await axios.put(`${API}/lotti/${lottoId}/archive`, {}, { headers: getAuthHeaders() });
      toast.success("Lotto archiviato");
      fetchData();
    } catch (error) {
      toast.error("Errore nell'archiviazione");
    }
    setArchiveDialogOpen(false);
    setLottoToArchive(null);
  };

  // Archivia tutti i lotti selezionati
  const archiviaSelezionati = async () => {
    if (selectedIds.length === 0) return;
    try {
      await Promise.all(
        selectedIds.map(id =>
          axios.put(`${API}/lotti/${id}/archive`, {}, { headers: getAuthHeaders() })
        )
      );
      toast.success(`${selectedIds.length} lott${selectedIds.length === 1 ? 'o archiviato' : 'i archiviati'}`);
      setSelectedIds([]);
      fetchData();
    } catch {
      toast.error("Errore nell'archiviazione multipla");
    }
  };

  // Ripristina lotto
  const handleRestore = async (lottoId) => {
    try {
      await axios.put(`${API}/lotti/${lottoId}/restore`, {}, { headers: getAuthHeaders() });
      toast.success("Lotto ripristinato");
      fetchData();
    } catch (error) {
      toast.error("Errore nel ripristino");
    }
  };

  // Elimina permanentemente
  const handlePermanentDelete = async (lottoId) => {
    try {
      await axios.delete(`${API}/lotti/${lottoId}/permanent`, { headers: getAuthHeaders() });
      toast.success("Lotto eliminato definitivamente");
      setSelectedIds(prev => prev.filter(id => id !== lottoId));
      fetchData();
    } catch (error) {
      toast.error("Errore nell'eliminazione");
    }
    setArchiveDialogOpen(false);
    setLottoToArchive(null);
  };

  // Apri dialog archivia/elimina
  const openArchiveDialog = (lottoOrId) => {
    const lotto = typeof lottoOrId === "string" ? lotti.find(l => l.id === lottoOrId) : lottoOrId;
    setLottoToArchive(lotto);
    setArchiveDialogOpen(true);
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEdit = !!form._editId || !!editItem;
    // In edit mode, non serve rivalidare l'ingrediente (già associato)
    if (!isEdit && !form.ingrediente_id && !form.nome_prodotto && !form.is_composto) {
      toast.error(ingredienti.length > 0 ? "Seleziona un ingrediente" : "Inserisci il nome del prodotto");
      return;
    }
    if (!form.numero_lotto?.trim()) {
      toast.error("Il numero di lotto è obbligatorio");
      return;
    }

    try {
      const { _editId, ...formData } = form;
      const data = { ...formData, locale_id: localeCorrente?.id };
      if (data.quantita_preparata === "" || data.quantita_preparata == null) {
        if (isEdit && editItem?.quantita_preparata != null) {
          toast.error("Inserisci una quantità valida");
          return;
        }
        delete data.quantita_preparata;
      } else {
        data.quantita_preparata = Number(String(data.quantita_preparata).replace(",", "."));
        if (!Number.isFinite(data.quantita_preparata) || data.quantita_preparata < 0) {
          toast.error("Inserisci una quantità valida");
          return;
        }
      }
      if (!data.unita_misura) delete data.unita_misura;
      // La data dopo apertura non è più modificabile: se assente nel lotto
      // storico, non crearla con un valore vuoto durante altri aggiornamenti.
      if (!data.data_scadenza_aperto) delete data.data_scadenza_aperto;
      if (!data.posizione && !editItem?.posizione) delete data.posizione;
      // tipo_creazione non va sovrascritto in edit (potrebbe essere "da_ricetta")
      if (!isEdit) data.tipo_creazione = "manuale";

      if (isEdit) {
        const lottoId = _editId || editItem?.id;
        const item = editItem || lotti.find(l => l.id === lottoId);
        const otherFields = ['ingrediente_id', 'numero_lotto', 'data_scadenza', 'data_apertura',
          'data_scadenza_aperto', 'quantita_testo', 'operatore', 'immagine_path', 'fattura_immagine_path',
          'quantita_preparata', 'unita_misura'];
        const onlyPosition = item && otherFields.every(key => (String(form[key] ?? '')) === (String(item[key] ?? ''))) &&
          (form.categoria || 'Altro') === (item.categoria || 'Altro');
        if (onlyPosition && (form.posizione || '') === (item.posizione || '')) {
          setDialogOpen(false);
          return;
        }
        if (onlyPosition) {
          await axios.patch(`${API}/lotti/${lottoId}`, { posizione: form.posizione || '' }, { headers: getAuthHeaders() });
        } else {
          if (!item?.data_apertura && !form.data_apertura) delete data.data_apertura;
          await axios.put(`${API}/lotti/${lottoId}`, data, { headers: getAuthHeaders() });
        }
        toast.success("Etichetta aggiornata");
        setDialogOpen(false);
        setCapturedImages([]);
        fetchData();
      } else {
        const res = await axios.post(`${API}/lotti`, data, { headers: getAuthHeaders() });
        setDialogOpen(false);
        setCapturedImages([]);
        fetchData();
        // Trigger dialog post-creazione (congelatore/abbattitore/fresco)
        if (res?.data?.id) {
          setPostCreaLotto({ id: res.data.id, nome: res.data.nome_prodotto || form.nome_prodotto || "", data_scadenza: res.data.data_scadenza || form.data_scadenza || "", posizione: res.data.posizione || form.posizione || "", lotto: res.data });
        }
      }
    } catch (error) {
      toast.error("Errore nel salvataggio");
    }
  };

  // Scansione handlers
  const openScanDialog = () => {
    toast.dismiss();
    setCapturedImages([]);
    setForm(prev => ({
      ...prev,
      ingrediente_id: "",
      nome_prodotto: "",
      numero_lotto: "",
      data_scadenza: "",
      data_apertura: new Date().toISOString().split('T')[0],
      data_scadenza_aperto: "",
      quantita_testo: "",
      quantita_preparata: "",
      unita_misura: "kg",
      operatore: formatNomeOperatore(user),
      immagine_path: "",
      fattura_immagine_path: "",
      posizione: "",
    }));
    setScanDialogOpen(true);
  };

  // Salva lotto da dialog "Scansiona"
  const handleSaveScanLotto = async () => {
    if (!form.ingrediente_id) {
      toast.error("Seleziona un ingrediente");
      return;
    }
    if (!form.data_scadenza) {
      toast.error("La data di scadenza è obbligatoria");
      return;
    }
    if (isDataScadenzaPassata(form.data_scadenza)) {
      toast.error("La scadenza rilevata è già passata. Correggila prima di salvare.");
      return;
    }
    if (!form.numero_lotto?.trim()) {
      toast.error("Il numero di lotto è obbligatorio");
      return;
    }
    setOcrLoading(true);
    try {
      const headers = getAuthHeaders();
      let immagine_path = "";

      // Upload foto se presente (non bloccante: se lo storage è pieno, salva comunque il lotto)
      if (capturedImages.length > 0 && capturedImages[0].file) {
        try {
          const formData = new FormData();
          formData.append("file", capturedImages[0].file);
          const uploadRes = await axios.post(`${API}/upload-image?locale_id=${localeCorrente?.id || "default"}`, formData, {
            headers: { ...headers, "Content-Type": "multipart/form-data" }
          });
          immagine_path = uploadRes.data.path;
        } catch (upErr) {
          const quota = upErr.response?.status === 439 || upErr.response?.data?.detail?.includes?.("quota");
          toast.warning(quota
            ? "Spazio archiviazione pieno: lotto salvato senza foto. Libera spazio o aggiorna il piano."
            : "Foto non caricata: lotto salvato senza immagine.");
        }
      }

      const data = {
        ingrediente_id: form.ingrediente_id,
        numero_lotto: form.numero_lotto || "",
        data_scadenza: form.data_scadenza || "",
        data_apertura: form.data_apertura || new Date().toISOString().split('T')[0],
        operatore: form.operatore || formatNomeOperatore(user),
        quantita_preparata: form.quantita_preparata ? parseFloat(form.quantita_preparata) : null,
        unita_misura: form.unita_misura || "kg",
        immagine_path: immagine_path,
        fattura_immagine_path: form.fattura_immagine_path || "",
        locale_id: localeCorrente?.id,
        tipo_creazione: "ingrediente",
      };

      const res = await axios.post(`${API}/lotti`, data, { headers });
      setScanDialogOpen(false);
      setCapturedImages([]);
      // Reset fattura per il prossimo lotto
      setForm(prev => ({ ...prev, fattura_immagine_path: "" }));
      // Ricarica storico fatture (nuovo path aggiunto)
      fetchFatturaStorico();
      fetchData();
      // Trigger dialog post-creazione (congelatore/abbattitore/fresco)
      if (res?.data?.id) {
        // Risolve nome ingrediente dal prodotto se possibile
        const ing = ingredienti.find((i) => i.id === form.ingrediente_id);
        const nome = ing?.nome || form.nome_prodotto || "";
        setPostCreaLotto({ id: res.data.id, nome, data_scadenza: res.data.data_scadenza || form.data_scadenza || "", posizione: res.data.posizione || "", lotto: res.data });
      }
    } catch (error) {
      toast.error("Errore nel salvataggio");
    } finally {
      setOcrLoading(false);
    }
  };

  const handleAddPhoto = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const { compressToWebP } = await import("../utils/imageCompressor");
      const { file: webpFile, base64, preview } = await compressToWebP(file, 0.9);
      setCapturedImages([{ file: webpFile, base64, preview }]);
      
      // Auto-run OCR subito dopo lo scatto
      setOcrLoading(true);
      try {
        const headers = getAuthHeaders();
        const ocrRes = await axios.post(`${API}/ocr/lotto`, {
          images_base64: [base64]
        }, { headers });
        const ocrData = ocrRes.data;
        setForm(prev => ({
          ...prev,
          ingrediente_id: ocrData.ingrediente_id || prev.ingrediente_id,
          numero_lotto: ocrData.numero_lotto || prev.numero_lotto,
          data_scadenza: ocrData.data_scadenza || prev.data_scadenza,
        }));
        const msgs = [];
        const scadenzaOCRPassata = isDataScadenzaPassata(ocrData.data_scadenza);
        if (ocrData.numero_lotto) msgs.push(`Lotto: ${ocrData.numero_lotto}`);
        if (ocrData.data_scadenza) {
          msgs.push(`Scadenza: ${ocrData.data_scadenza}`);
          if (scadenzaOCRPassata) {
            toast.error("La scadenza rilevata è già passata. Correggila prima di salvare.");
          }
        }
        if (ocrData.ingrediente_id) msgs.push("Ingrediente trovato");
        if (!scadenzaOCRPassata && msgs.length > 0) toast.success(`Dati estratti: ${msgs.join(' | ')}`);
        else if (!scadenzaOCRPassata) toast.warning("OCR non ha trovato lotto/scadenza - inserisci manualmente");
      } catch {
        toast.error("Errore OCR, inserisci i dati manualmente");
      } finally {
        setOcrLoading(false);
      }
    } catch (error) {
      toast.error("Errore nel caricamento della foto");
    }
    
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const removePhoto = (index) => {
    setCapturedImages(prev => prev.filter((_, i) => i !== index));
  };

  // ─── Fattura Lotto ──────────────────────────────────────────
  // Storico ultime 10 fatture caricate dalla società (per riutilizzo)
  const fetchFatturaStorico = async () => {
    try {
      const headers = getAuthHeaders();
      const res = await axios.get(`${API}/fatture-storico?limit=10`, { headers });
      setFatturaStorico(res.data?.items || []);
    } catch { /* silent */ }
  };

  // Nuovo scatto fattura: compressione WebP + upload → salva path nel form
  const handleFatturaNuovoScatto = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setFatturaUploading(true);
    try {
      const { compressToWebP } = await import("../utils/imageCompressor");
      const { file: webpFile, preview } = await compressToWebP(file, 0.85);
      const headers = getAuthHeaders();
      const formData = new FormData();
      formData.append("file", webpFile);
      const res = await axios.post(
        `${API}/upload-fattura-image?locale_id=${localeCorrente?.id || "default"}`,
        formData,
        { headers: { ...headers, "Content-Type": "multipart/form-data" } }
      );
      const path = res.data?.path;
      if (path) {
        rememberFatturaPreview(path, webpFile, preview);
        setForm(prev => ({ ...prev, fattura_immagine_path: path }));
        // aggiorna storico locale (path in cima) senza aspettare il refetch
        setFatturaStorico(prev => [{ path, pending: true, last_used_at: new Date().toISOString() },
          ...prev.filter(x => x.path !== path)].slice(0, 10));
        toast.success("Fattura caricata");
        setFatturaSheetOpen(false);
      }
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.message || "Errore sconosciuto";
      console.error("Errore caricamento fattura:", err);
      toast.error(`Errore caricamento fattura: ${detail}`);
    } finally {
      setFatturaUploading(false);
      if (fatturaFileInputRef.current) fatturaFileInputRef.current.value = "";
    }
  };

  const handleFatturaSelectFromStorico = (path) => {
    setForm(prev => ({ ...prev, fattura_immagine_path: path }));
    setFatturaSheetOpen(false);
    toast.success("Fattura selezionata dallo storico");
  };

  const handleFatturaRemove = () => {
    setForm(prev => ({ ...prev, fattura_immagine_path: "" }));
  };

  // OCR: leggi dati dalla foto
  const runOCR = async () => {
    if (capturedImages.length === 0) return;
    setOcrLoading(true);
    try {
      const headers = getAuthHeaders();
      const ocrRes = await axios.post(`${API}/ocr/lotto`, {
        images_base64: [capturedImages[0].base64]
      }, { headers });

      const ocrData = ocrRes.data;
      setForm(prev => ({
        ...prev,
        ingrediente_id: ocrData.ingrediente_id || prev.ingrediente_id,
        numero_lotto: ocrData.numero_lotto || prev.numero_lotto,
        data_scadenza: ocrData.data_scadenza || prev.data_scadenza,
      }));

      const msgs = [];
      const scadenzaOCRPassata = isDataScadenzaPassata(ocrData.data_scadenza);
      if (ocrData.ingrediente_suggerito) msgs.push(`Ingrediente: ${ocrData.ingrediente_suggerito}`);
      if (ocrData.numero_lotto) msgs.push(`Lotto: ${ocrData.numero_lotto}`);
      if (ocrData.data_scadenza) {
        msgs.push(`Scadenza: ${ocrData.data_scadenza}`);
        if (scadenzaOCRPassata) {
          toast.error("La scadenza rilevata è già passata. Correggila prima di salvare.");
        }
      }

      if (!scadenzaOCRPassata && msgs.length > 0) {
        toast.success(`Dati estratti: ${msgs.join(' | ')}`, { duration: 5000 });
      } else if (!scadenzaOCRPassata) {
        toast.warning("OCR non ha trovato dati - inserisci manualmente");
      }
    } catch (error) {
      toast.error("Errore OCR - inserisci i dati manualmente");
    } finally {
      setOcrLoading(false);
    }
  };

  // Creazione nuovo ingrediente
  const handleCreateIngrediente = async (e) => {
    e.preventDefault();
    if (!newIngredienteForm.nome.trim()) {
      toast.error("Inserisci il nome dell'ingrediente");
      return;
    }
    try {
      const payload = { 
        nome: newIngredienteForm.nome.trim(),
        locale_id: localeCorrente?.id,
        categoria_id: newIngredienteForm.categoria_id || null,
        unita_misura: newIngredienteForm.unita_misura || "kg"
      };
      const response = await axios.post(`${API}/ingredienti`, payload, { headers: getAuthHeaders() });
      toast.success(`Ingrediente "${response.data.nome}" creato e selezionato`);
      setIngredienti(prev => [...prev, response.data]);
      setForm(prev => ({ ...prev, ingrediente_id: response.data.id }));
      setNewIngredienteDialogOpen(false);
      setNewIngredienteForm({ nome: "", categoria_id: "", unita_misura: "kg" });
    } catch (error) {
      toast.error("Errore nella creazione");
    }
  };

  // I lotti nuovi mantengono lo stato HACCP interno "fresco"; il metodo scelto
  // distingue frigo e temperatura ambiente senza modificare i lotti storici.
  const handleConserva = async (dataScadenza, posizione, metodo) => {
    if (!postCreaLotto) return;
    const lottoId = postCreaLotto.id;
    setSavingStato(true);
    try {
      const update = { posizione: posizione || "", metodo_conservazione: metodo };
      if (dataScadenza) update.data_scadenza = dataScadenza;
      await axios.patch(`${API}/lotti/${lottoId}`, update, { headers: getAuthHeaders() });
      setPostCreaLotto(null);
      await fetchData();
      toast.success(`Lotto salvato in ${metodo === "temp_ambiente" ? "temp. ambiente" : "frigo"}. Stampa l'etichetta!`);
      setTimeout(() => generaPdfEtichetta([lottoId]), 300);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore salvataggio scadenza");
    } finally {
      setSavingStato(false);
    }
  };

  const handleCongela = async (lottoDaConservare, datiConservazione, daPostCreazione = false) => {
    if (!lottoDaConservare) return;
    setSavingStato(true);
    try {
      const body = {
        data_congelamento: datiConservazione.data,
        note: datiConservazione.note || null,
        metodo: datiConservazione.metodo || "congelatore",
      };
      if (datiConservazione.posizione !== undefined) body.posizione = datiConservazione.posizione;
      if (datiConservazione.data_scadenza_custom) {
        body.data_scadenza = datiConservazione.data_scadenza_custom;
      } else {
        body.mesi_validita = parseInt(datiConservazione.mesi || 3, 10);
      }
      const qp = Number(String(datiConservazione.quantita_parziale || "").replace(",", "."));
      if (!isNaN(qp) && qp > 0) body.quantita_parziale = qp;
      const res = await axios.post(`${API}/lotti/${lottoDaConservare.id}/congela`, body, { headers: getAuthHeaders() });
      const isAbb = (datiConservazione.metodo || "congelatore") === "abbattitore";
      setCongelaLotto(null);
      if (daPostCreazione) setPostCreaLotto(null);
      await fetchData();
      if (res.data?.split) {
        const childId = res.data.lotto_congelato?.id;
        toast.success(isAbb ? "Abbattimento parziale: creato nuovo lotto abbattuto." : "Congelamento parziale: creato nuovo lotto congelato. Stampa l'etichetta!");
        if (childId) setTimeout(() => generaPdfEtichetta([childId]), 300);
      } else {
        toast.success(isAbb ? "Lotto abbattuto. Stampa la nuova etichetta!" : "Lotto congelato. Stampa la nuova etichetta!");
        if (res.data?.id) setTimeout(() => generaPdfEtichetta([res.data.id]), 300);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore congelamento");
    } finally {
      setSavingStato(false);
    }
  };

  const handleScongela = async () => {
    if (!scongelaLotto) return;
    setSavingStato(true);
    try {
      const body = {
        data_scongelamento: scongelaForm.data,
        note: scongelaForm.note || null,
        destinazione: scongelaForm.destinazione || "frigo",
      };
      if (scongelaForm.posizione !== undefined) body.posizione = scongelaForm.posizione;
      if (scongelaForm.destinazione !== "congelatore") {
        if (scongelaForm.data_scadenza_custom) {
          body.data_scadenza = scongelaForm.data_scadenza_custom;
        } else {
          body.giorni_validita = parseInt(scongelaForm.giorni || 2, 10);
        }
      }
      // Quantità parziale valida sia per frigo (scongela) che per congelatore (spostamento)
      const qp = parseFloat(scongelaForm.quantita_parziale);
      if (!isNaN(qp) && qp > 0) body.quantita_parziale = qp;

      const res = await axios.post(`${API}/lotti/${scongelaLotto.id}/scongela`, body, { headers: getAuthHeaders() });
      setScongelaLotto(null);
      await fetchData();
      if (res.data?.split) {
        const childId = res.data.lotto_congelato?.id || res.data.lotto_scongelato?.id;
        toast.success(body.destinazione === "congelatore"
          ? "Spostamento parziale: creato nuovo lotto in congelatore. Stampa l'etichetta!"
          : "Scongelamento parziale: creato nuovo lotto in frigo. Stampa l'etichetta!");
        if (childId) setTimeout(() => generaPdfEtichetta([childId]), 300);
      } else if (body.destinazione === "congelatore") {
        toast.success("Lotto spostato in congelatore");
      } else {
        toast.success("Lotto scongelato. Stampa la nuova etichetta!");
        if (res.data?.id) setTimeout(() => generaPdfEtichetta([res.data.id]), 300);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore scongelamento");
    } finally {
      setSavingStato(false);
    }
  };

  const generaPdfEtichetta = async (lottoIds) => {
    try {
      const wizardAperto = () => Boolean(document.querySelector('[data-testid="post-creazione-lotto-dialog"], [data-testid="scan-dialog"]'));
      if (!wizardAperto()) toast.loading("Generazione PDF etichetta...", { id: "pdf-gen" });
      const notificaPdf = (message) => {
        if (wizardAperto()) toast.dismiss("pdf-gen");
        else toast.success(message, { id: "pdf-gen" });
      };
      const res = await axios.post(`${API}/lotti/stampa-pdf`, {
        lotto_ids: lottoIds,
        width_mm: labelSize.width,
        height_mm: labelSize.height,
        rotated: labelSize.rotated
      }, {
        headers: getAuthHeaders(),
        responseType: "blob"
      });

      const blob = new Blob([res.data], { type: "application/pdf" });
      const filename = `etichette_${lottoIds.length}_lotti_${Date.now()}.pdf`;
      const pdfFile = new File([blob], filename, { type: "application/pdf" });

      // ─── Rilevamento dispositivo (Touch primario → mobile/tablet) ───
      const ua = navigator.userAgent || "";
      const isMobileOrTablet =
        /Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(ua) ||
        (typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches);

      // ═══════════════════════════════════════════════════════
      // FLOW MOBILE / TABLET: Web Share API (AirPrint / Mopria)
      // ═══════════════════════════════════════════════════════
      if (isMobileOrTablet) {
        const canShareFiles =
          typeof navigator !== "undefined" &&
          navigator.canShare &&
          navigator.share &&
          navigator.canShare({ files: [pdfFile] });

        if (canShareFiles) {
          try {
            await navigator.share({
              files: [pdfFile],
              title: "Etichette Yollo",
              text: `${lottoIds.length} etichett${lottoIds.length === 1 ? "a" : "e"} pronte da stampare`,
            });
            notificaPdf("Etichette pronte — tocca 'Stampa' nel menu Condividi");
            return;
          } catch (err) {
            if (err?.name === "AbortError") { toast.dismiss("pdf-gen"); return; }
            console.warn("Web Share fallito, fallback a download:", err);
          }
        }
        // Fallback mobile senza Web Share → download diretto (l'utente apre dal file)
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
        notificaPdf("PDF scaricato — apri il file e stampalo");
        return;
      }

      // ═══════════════════════════════════════════════════════
      // FLOW DESKTOP: apertura affidabile in nuova tab via iframe
      // ═══════════════════════════════════════════════════════
      const blobUrl = URL.createObjectURL(blob);

      // 1. Apri SUBITO la nuova tab (gesto utente non scaduto)
      const previewTab = window.open(blobUrl, "_blank", "noopener,noreferrer");

      if (previewTab) {
        // 2. Mostra dialog/toast con istruzioni + bottone download esplicito
        toast.success(
          ((t) => (
            <div className="flex items-start gap-2">
              <div className="flex-1 text-sm">
                <p className="font-semibold">PDF aperto nella nuova tab</p>
                <p className="text-xs text-muted-foreground mt-0.5">Premi <kbd className="px-1.5 py-0.5 bg-muted rounded text-[10px] font-mono">Ctrl+P</kbd> (o <kbd className="px-1.5 py-0.5 bg-muted rounded text-[10px] font-mono">⌘P</kbd>) per stampare</p>
              </div>
              <button
                type="button"
                onClick={() => {
                  const a = document.createElement("a");
                  a.href = blobUrl;
                  a.download = filename;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  toast.dismiss(t);
                }}
                className="px-2 py-1 bg-primary text-primary-foreground rounded text-xs font-semibold hover:opacity-90"
              >
                Scarica
              </button>
            </div>
          )),
          { id: "pdf-gen", duration: 10000 }
        );
      } else {
        // Popup bloccato → download immediato come fallback
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        notificaPdf("PDF scaricato — apri il file e usa Ctrl+P per stampare");
      }

      setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
    } catch (err) {
      console.error("Errore generazione PDF:", err);
      toast.error("Errore nella generazione del PDF", { id: "pdf-gen" });
    }
  };

  // Stampa singolo lotto (dal modale)
  const stampaSingoloLotto = (lotto) => {
    generaPdfEtichetta([lotto.id]);
  };

  // Stampa etichette multiple (dalla selezione)
  const stampaEtichette = () => {
    const etichetteDaStampare = [...lotti, ...lottiArchiviati].filter(l => selectedIds.includes(l.id));
    if (etichetteDaStampare.length === 0) {
      toast.error("Seleziona almeno un'etichetta");
      return;
    }
    generaPdfEtichetta(etichetteDaStampare.map(l => l.id));
  };

  // --- RENDER ---
  const filterCount = (filterGiorni !== null ? 1 : 0) + (filterCategoria ? 1 : 0) + (sortBy !== "scadenza" ? 1 : 0) + (filterStato !== "tutti" ? 1 : 0);

  return (
    <div className="page-container pb-32" data-testid="lotti-page">
      {/* Header Desktop */}
      <div className="hidden md:block">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="page-title">Tracciabilità Lotti</h1>
            <p className="page-subtitle">Gestisci lotti acquistati e preparazioni</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate("/lotti/archivio")}
              className="flex items-center gap-2 px-3 py-2 rounded-xl bg-muted hover:bg-muted/80 border border-border text-sm text-muted-foreground transition-colors"
              data-testid="archivio-link-desktop"
            >
              <Archive className="h-4 w-4" />
              Archivio ({lottiArchiviati.length})
            </button>
            <button
              onClick={() => { setTempLabelSize({ ...labelSize }); setLabelSettingsOpen(true); }}
              className="flex items-center gap-2 px-3 py-2 rounded-xl bg-muted hover:bg-muted/80 border border-border text-sm text-muted-foreground transition-colors"
              data-testid="label-settings-btn"
            >
              <Printer className="h-4 w-4" />
              <span>{labelSize.width}x{labelSize.height}mm</span>
              {labelSize.rotated && <RotateCw className="h-3 w-3" />}
            </button>
          </div>
        </div>
      </div>

      {/* Header Mobile */}
      <div className="md:hidden flex items-center justify-between">
        <h1 className="font-extrabold text-xl tracking-tight">Lotti</h1>
        <div className="flex items-center gap-1.5">
          <button
            onClick={() => navigate("/lotti/archivio")}
            className="flex items-center justify-center w-10 h-10 rounded-xl bg-muted border border-border text-muted-foreground"
            data-testid="archivio-link-mobile"
            aria-label="Archivio"
          >
            <Archive className="h-4 w-4" />
          </button>
          <button
            onClick={() => { setTempLabelSize({ ...labelSize }); setLabelSettingsOpen(true); }}
            className="flex items-center justify-center w-10 h-10 rounded-xl bg-muted border border-border text-muted-foreground"
            data-testid="label-settings-btn-mobile"
            aria-label="Impostazioni etichetta"
          >
            <Printer className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Hero stato cucina */}
      <StatoCucinaHero
        scaduti={lottiScaduti}
        inScadenza={lottiInScadenza}
        onClick={() => { setFilterGiorni(7); setSearchQuery(""); }}
      />

      {/* Tab stato HACCP — stati e scaduti sempre contenuti nel viewport */}
      <div className="grid grid-cols-3 items-center gap-1.5 pb-1 sm:flex sm:gap-2" data-testid="stato-pills">
        {[
          { key: "tutti", label: "Tutti", count: lotti.length, iconEmoji: "" },
          { key: "frigo", label: "Frigo", count: countByStato.frigo, iconEmoji: "" },
          { key: "temp_ambiente", label: "Temp. ambiente", mobileLabel: "Ambiente", count: countByStato.temp_ambiente, iconEmoji: "" },
          { key: "congelato", label: "In congelatore", mobileLabel: "Congelati", count: countByStato.congelato, iconEmoji: "❄️", activeBg: "bg-sky-600", inactiveText: "text-sky-700 dark:text-sky-400", border: "border-sky-300 dark:border-sky-500/40" },
          { key: "scongelato", label: "Scongelati", count: countByStato.scongelato, iconEmoji: "☀️", activeBg: "bg-orange-600", inactiveText: "text-orange-700 dark:text-orange-400", border: "border-orange-300 dark:border-orange-500/40" },
          { key: "scaduti", label: "Scaduti", count: countByStato.scaduti, iconEmoji: "⚠", activeBg: "bg-red-600", inactiveText: "text-red-700 dark:text-red-400", border: "border-red-300 dark:border-red-500/40" },
        ].map(p => {
          const isActive = filterStato === p.key;
          const baseInactive = "bg-card text-foreground border-border";
          const inactiveCls = p.inactiveText ? `bg-card ${p.inactiveText} ${p.border}` : baseInactive;
          return (
            <button
              key={p.key}
              onClick={() => setFilterStato(p.key)}
              className={`flex min-w-0 items-center justify-center gap-1 h-9 px-1.5 sm:px-3.5 rounded-full border text-[11px] sm:text-xs font-bold whitespace-nowrap transition-[background-color,color,border-color] sm:flex-shrink-0 ${
                isActive ? `${p.activeBg || "bg-primary"} text-white border-transparent` : inactiveCls
              }`}
              data-testid={`stato-pill-${p.key}`}
            >
              {p.iconEmoji && <span>{p.iconEmoji}</span>}
              {p.mobileLabel ? <><span className="truncate sm:hidden">{p.mobileLabel}</span><span className="hidden sm:inline">{p.label}</span></> : <span className="truncate">{p.label}</span>}
              <span className={`shrink-0 text-[9px] sm:text-[10px] px-1 sm:px-1.5 py-0.5 rounded-full font-bold ${isActive ? "bg-white/20" : "bg-muted"}`}>
                {p.count}
              </span>
            </button>
          );
        })}
      </div>

      {/* Search + Filtri compatti in 1 sola riga */}
      <div className="flex items-center gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3.5 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handleAddPhoto}
            className="hidden"
          />
          <input
            ref={fatturaFileInputRef}
            type="file"
            accept="image/*"
            capture="environment"
            onChange={handleFatturaNuovoScatto}
            className="hidden"
            data-testid="fattura-file-input"
          />
          <Input
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Cerca lotto, prodotto..."
            className="pl-10 h-11 bg-card border-border text-foreground placeholder:text-muted-foreground rounded-xl"
            data-testid="search-lotti"
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 p-1 hover:bg-muted rounded-full"
            >
              <X className="h-4 w-4 text-muted-foreground" />
            </button>
          )}
        </div>
        <button
          onClick={() => setFiltersSheetOpen(true)}
          className={`relative flex items-center gap-1.5 h-11 px-4 rounded-xl border text-sm font-semibold transition-all ${
            filterCount > 0
              ? "bg-primary text-white border-primary"
              : "bg-card text-foreground border-border"
          }`}
          data-testid="open-filters-sheet"
        >
          <SlidersHorizontal className="h-4 w-4" />
          Filtri
          {filterCount > 0 && (
            <span className="ml-1 inline-flex items-center justify-center w-5 h-5 rounded-full bg-amber-400 text-black text-[11px] font-bold">{filterCount}</span>
          )}
        </button>
      </div>

      {/* Lista lotti */}
      <div className="mt-2">
        {loading ? (
          <div className="space-y-2">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-20 bg-card rounded-xl animate-pulse" />
            ))}
          </div>
        ) : sortedLotti.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 px-4 bg-card rounded-2xl border border-border">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
              <ChefHat className="h-8 w-8 text-amber-600" />
            </div>
            <p className="text-foreground font-bold text-base mb-1">
              {searchQuery || filterGiorni || filterCategoria ? "Nessun lotto trovato" : "Nessun lotto attivo"}
            </p>
            <p className="text-sm text-muted-foreground text-center max-w-xs">
              {searchQuery || filterGiorni || filterCategoria
                ? "Prova a modificare i filtri o la ricerca."
                : "Tocca il pulsante Prepara in basso a destra per creare il primo lotto."}
            </p>
          </div>
        ) : (
          <>
            {/* Toolbar selezione + count */}
            <div className="flex items-center justify-between mb-2">
              <div
                onClick={toggleSelectAll}
                className="flex items-center gap-2 px-3 py-2 rounded-full bg-muted active:bg-muted/80 transition-colors cursor-pointer"
                data-testid="select-all-btn"
                role="button"
                tabIndex={0}
              >
                <Checkbox
                  checked={selectedIds.length === sortedLotti.length && sortedLotti.length > 0}
                  className="border-muted-foreground/30 data-[state=checked]:bg-lime-400 data-[state=checked]:border-lime-400 pointer-events-none"
                />
                <span className="text-xs font-medium text-muted-foreground">
                  {selectedIds.length > 0 ? `${selectedIds.length} selezionat${selectedIds.length === 1 ? 'o' : 'i'}` : "Seleziona"}
                </span>
              </div>
              <span className="text-xs text-muted-foreground">{sortedLotti.length} lotti</span>
            </div>

            {/* Lista lotti — raggruppata per stato se non filtrato */}
            {filterStato !== "tutti" ? (
              <div className="space-y-2 md:grid md:grid-cols-2 md:gap-3 md:space-y-0 lg:grid-cols-3" data-testid="lotti-list">
                {sortedLotti.map((item) => (
                  <LottoCard
                    key={item.id}
                    lotto={item}
                    prodottoNome={getIngredienteNome(item.ingrediente_id, item.prodotto_id, item)}
                    posizioneNome={getNomePosizione(item.posizione)}
                    isSelected={selectedIds.includes(item.id)}
                    onSelect={toggleSelect}
                    onClick={() => handleLottoClick(item)}
                  />
                ))}
              </div>
            ) : (() => {
              // I lotti senza metodo registrato restano nel gruppo Frigo (legacy).
              const groups = { frigo: [], temp_ambiente: [], congelato: [], abbattuto: [], scongelato: [] };
              sortedLotti.forEach((l) => {
                const gruppo = gruppoConservazione(l);
                (groups[gruppo] || groups.frigo).push(l);
              });
              const sectionMeta = {
                frigo:     { title: "Frigo",         Icon: null,       color: "text-emerald-600", borderColor: "border-emerald-200" },
                temp_ambiente: { title: "Temp. ambiente", Icon: null, color: "text-amber-700", borderColor: "border-amber-200" },
                congelato: { title: "In congelatore", Icon: null,      color: "text-sky-600",     borderColor: "border-sky-200" },
                abbattuto: { title: "In abbattitore", Icon: null,      color: "text-indigo-600",  borderColor: "border-indigo-200" },
                scongelato:{ title: "Scongelati",    Icon: null,       color: "text-orange-600",  borderColor: "border-orange-200" },
              };
              return (
                <div className="space-y-4" data-testid="lotti-list">
                  {Object.entries(groups).map(([stato, items]) => {
                    if (items.length === 0) return null;
                    const meta = sectionMeta[stato];
                    return (
                      <div key={stato} data-testid={`lotti-section-${stato}`}>
                        <div className={`flex items-center gap-2 mb-2 pb-1.5 border-b ${meta.borderColor}`}>
                          <h3 className={`text-xs font-bold uppercase tracking-wider ${meta.color}`}>{meta.title}</h3>
                          <span className="text-[10px] text-muted-foreground bg-muted px-1.5 py-0.5 rounded-full">{items.length}</span>
                        </div>
                        <div className="space-y-2 md:grid md:grid-cols-2 md:gap-3 md:space-y-0 lg:grid-cols-3">
                          {items.map((item) => (
                            <LottoCard
                              key={item.id}
                              lotto={item}
                              prodottoNome={getIngredienteNome(item.ingrediente_id, item.prodotto_id, item)}
                              posizioneNome={getNomePosizione(item.posizione)}
                              isSelected={selectedIds.includes(item.id)}
                              onSelect={toggleSelect}
                              onClick={() => handleLottoClick(item)}
                            />
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })()}

            {selectedIds.length > 0 && <div className="h-20" />}
          </>
        )}
      </div>

      {/* Filters Bottom Sheet */}
      <FiltersBottomSheet
        open={filtersSheetOpen}
        onOpenChange={setFiltersSheetOpen}
        filterGiorni={filterGiorni}
        setFilterGiorni={setFilterGiorni}
        filterCategoria={filterCategoria}
        setFilterCategoria={setFilterCategoria}
        sortBy={sortBy}
        setSortBy={setSortBy}
        categorieUsate={categorieUsate}
      />

      {/* FAB Speed Dial */}
      <FabSpeedDial
        onPrepara={() => setPreparaDialogOpen(true)}
        onScansiona={openScanDialog}
        selectedCount={selectedIds.length}
        onArchivia={archiviaSelezionati}
        onStampa={stampaEtichette}
      />


      {/* Modale Azioni Lotto */}
      <LottoActionModal
        open={actionModalOpen}
        onClose={() => { setActionModalOpen(false); setSelectedLottoForAction(null); }}
        lotto={selectedLottoForAction}
        prodottoNome={selectedLottoForAction ? getIngredienteNome(selectedLottoForAction.ingrediente_id, selectedLottoForAction.prodotto_id, selectedLottoForAction) : ""}
        onPrint={stampaSingoloLotto}
        onEdit={item => {
          if (item.is_archived) {
            setPositionOnlyLotto(item);
            setPositionOnlyValue(item.posizione || "");
          } else openDialog(item);
        }}
        onCongela={(l) => { setCongelaLotto(l); setCongelaForm({ data: new Date().toISOString().slice(0,10), mesi: 3, data_scadenza_custom: "", note: "", metodo: "congelatore", quantita_parziale: (l?.quantita_preparata != null && l?.quantita_preparata !== "" && !isNaN(parseFloat(l.quantita_preparata))) ? String(l.quantita_preparata) : "" }); }}
        onScongela={(l) => { setScongelaLotto(l); setScongelaForm({ data: new Date().toISOString().slice(0,10), giorni: 2, data_scadenza_custom: "", note: "", destinazione: "frigo", quantita_parziale: "" }); }}
        onArchive={openArchiveDialog}
        onRestore={handleRestore}
        onDelete={handlePermanentDelete}
        isArchived={selectedLottoForAction?.is_archived}
      />

      {/* Dialog Archivia/Elimina */}
      <ArchiveConfirmDialog
        open={archiveDialogOpen}
        onOpenChange={setArchiveDialogOpen}
        onArchive={() => lottoToArchive && handleArchive(lottoToArchive.id)}
        onDelete={() => lottoToArchive && handlePermanentDelete(lottoToArchive.id)}
        lottoName={lottoToArchive ? getIngredienteNome(lottoToArchive.ingrediente_id, lottoToArchive.prodotto_id, lottoToArchive) : "questo lotto"}
      />

      {/* Dialog Scansione */}
      <ScanDialog
        open={scanDialogOpen}
        onOpenChange={setScanDialogOpen}
        form={form}
        setForm={setForm}
        capturedImages={capturedImages}
        setCapturedImages={setCapturedImages}
        fileInputRef={fileInputRef}
        onAddPhoto={() => fileInputRef.current?.click()}
        onRunOCR={runOCR}
        ocrLoading={ocrLoading}
        onSave={handleSaveScanLotto}
        ingredienti={ingredienti}
        categorie={categorie}
        onCreateIngrediente={() => setNewIngredienteDialogOpen(true)}
        onOpenFattura={() => { fetchFatturaStorico(); setFatturaSheetOpen(true); }}
        onRemoveFattura={handleFatturaRemove}
        fatturaPreviewUrl={getFatturaPreview(form.fattura_immagine_path)}
      />

      {/* Dialog Nuova/Modifica Etichetta */}
      <EtichettaDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        editItem={editItem}
        form={form}
        setForm={setForm}
        onSubmit={handleSubmit}
        ingredienti={ingredienti}
        categorie={categorie}
        posizioni={posizioni}
        frigoriferi={frigoriferi}
        onCreateIngrediente={() => setNewIngredienteDialogOpen(true)}
      />

      {/* Dialog Nuovo Ingrediente */}
      <NuovoIngredienteDialog
        open={newIngredienteDialogOpen}
        onOpenChange={setNewIngredienteDialogOpen}
        form={newIngredienteForm}
        setForm={setNewIngredienteForm}
        onSubmit={handleCreateIngrediente}
        categorie={categorie}/>

      {/* ════ DIALOG POST-CREAZIONE LOTTO (Fresco / Congelatore / Abbattitore) ════ */}
      <PostCreazioneLottoDialog
        open={!!postCreaLotto}
        onOpenChange={(o) => !o && setPostCreaLotto(null)}
        lotto={postCreaLotto?.lotto}
        nomeProdotto={postCreaLotto?.nome || ""}
        defaultScadenza={postCreaLotto?.data_scadenza || ""}
        defaultPosizione={postCreaLotto?.posizione || ""}
        frigoriferi={frigoriferi}
        posizioni={posizioni}
        saving={savingStato}
        onConserva={handleConserva}
        onCongela={values => handleCongela(postCreaLotto?.lotto || { id: postCreaLotto?.id }, values, true)}
      />

      <LottoPositionDialog lotto={positionOnlyLotto} value={positionOnlyValue} onChange={setPositionOnlyValue}
        onClose={() => setPositionOnlyLotto(null)} onSave={handlePositionOnlySave}
        saving={positionOnlySaving} frigoriferi={frigoriferi} posizioni={posizioni} />

      {/* ════ DIALOG CONGELA LOTTO ════ */}
      <CongelaLottoDialog
        lotto={congelaLotto}
        open={!!congelaLotto}
        onOpenChange={(o) => !o && setCongelaLotto(null)}
        form={congelaForm}
        setForm={setCongelaForm}
        saving={savingStato}
        onConferma={() => handleCongela(congelaLotto, congelaForm)}
        getNomeIngrediente={getIngredienteNome}
        frigoriferi={frigoriferi}
        posizioni={posizioni}
      />

      {/* ════ DIALOG SCONGELA LOTTO ════ */}
      <ScongelaLottoDialog
        lotto={scongelaLotto}
        open={!!scongelaLotto}
        onOpenChange={(o) => !o && setScongelaLotto(null)}
        form={scongelaForm}
        setForm={setScongelaForm}
        saving={savingStato}
        onConferma={handleScongela}
        getNomeIngrediente={getIngredienteNome}
        frigoriferi={frigoriferi}
        posizioni={posizioni}
      />

      {/* Dialog Impostazioni Etichetta */}
      <LabelSettingsDialog
        open={labelSettingsOpen}
        onOpenChange={setLabelSettingsOpen}
        tempSize={tempLabelSize}
        setTempSize={setTempLabelSize}
        onSave={saveLabelSize}
      />

      {/* Dialog Prepara */}
      <PreparaDialog
        open={preparaDialogOpen}
        onClose={() => { setPreparaDialogOpen(false); setRicettaIdDaUrl(null); }}
        localeId={localeCorrente?.id}
        getAuthHeaders={getAuthHeaders}
        operatore={formatNomeOperatore(user)}
        onSuccess={(lottoCreato) => {
          fetchData();
          // Trigger dialog post-creazione anche per preparazione
          if (lottoCreato?.id) {
            setPostCreaLotto({ ...lottoCreato, lotto: lottoCreato.lotto || { id: lottoCreato.id, locale_id: localeCorrente?.id } });
          }
        }}
        ricettaIniziale={ricettaIdDaUrl}
        lottiDisponibili={lotti}
      />

      {/* Sheet Carica Fattura — galleria storico + nuovo scatto */}
      <FatturaSheet
        open={fatturaSheetOpen}
        onOpenChange={setFatturaSheetOpen}
        storico={fatturaStorico}
        localPreviews={fatturaPreviewUrls}
        onSelectStorico={handleFatturaSelectFromStorico}
        onNuovoScatto={() => fatturaFileInputRef.current?.click()}
        uploading={fatturaUploading}
      />

      {/* Spazio per la bottom bar fissa */}
      {selectedIds.length > 0 && <div className="h-20" />}
    </div>
  );
};

export default Lotti;
